module.exports = __webpack_public_path__ + "img/banner-casa-trabalhador.ad91344f.jpg";